/**
 *
 * Events
 *
 */

import { mapGetters, mapMutations, mapActions } from 'vuex';
import Swal from 'sweetalert2';
import $ from 'jquery';

import { cookieHasItem, cookieRemoveItem } from '@/global/cookie';

import TrackerButton from '@/components/TrackerButton.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Aside from '@/components/Aside.vue';
//import TabBar from '@/components/TabBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import Question from '@/components/Question/Question.vue';
//import PzButton from '@/components/PzButton.vue';

import LatestPaperList from '@/views/Events/components/LatestPaperList.vue';
import HistoryPaperList from '@/views/Events/components/HistoryPaperList.vue';
import MyPaperList from '@/views/Events/components/MyPaperList.vue';

import { LOADING_MESSAGE } from './Events.constants';

export default {
  name: 'Events',

  components: {
    WayFindBar,
    Footer,
    //TabBar,
    Question,
    Spinner,
    Aside,
    //PzButton,
    TrackerButton,
    LatestPaperList,
    HistoryPaperList,
    MyPaperList,
  },

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,
      isShowMock: false,
      isTakingExam: true,
      eventTitle: '',
      currentPaper: {},
      hasAfter: true,
      itvlMockFinish: null,
    };
  },

  computed: {
    ...mapGetters({
      immLoading: 'immLoading',
      isRequest: 'Events/isRequest',
      QuestionList: 'Events/QuestionList',
      Question: 'Events/Question',
      BeforeMockData: 'Events/BeforeMockData',
      AfterMockData: 'Events/AfterMockData',
    }),
  },

  methods: {
    ...mapMutations('Events', {
      mm_GET_EVENTS_SUCCESS: 'GET_EVENTS_SUCCESS',
      mm_SAVE_QUESTION_RANGY_MARK: 'SAVE_QUESTION_RANGY_MARK',
    }),

    ...mapActions({
      getEvents: 'Events/getEvents',
      ma_getBeforeMock: 'Events/getBeforeMock',
      ma_getRedoBeforeMock: 'Events/getRedoBeforeMock',
      getMockData: 'Events/getMockData',
      handInPaper: 'Events/handInPaper',
      answer: 'Events/answer',
      getQuestion: 'Events/getQuestion',
    }),

    ...mapActions('Events', {
      ma_updateQuestionHtml: 'updateQuestionHtml',
    }),

    loadCKEditorScript() {
      //if (!window.pz_ckeditor) {
      //  const myScript = document.createElement('script');
      //  myScript.setAttribute('src', 'https://class.pzacademy.com/js/ckeditor.js');
      //  // myScript.onload = callback;
      //  document.body.appendChild(myScript);
      //  window.pz_ckeditor = true;
      //}
    },

    goBack() {
      this.$router.go(-1);
    },

    async fetchEvents() {
      this.mm_GET_EVENTS_SUCCESS([]);
      await this.getEvents();
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },

    openSelectableModal(inProgressEvent) {
      $('#selectableModal').modal('show');
      this.currentPaper = inProgressEvent;
      this.getBeforeMock({ paperId: this.currentPaper.paperId });
    },

    go2DemoMock() {
      $('#selectableModal').modal('hide');
      if (this.currentPaper.examType == 6) {
        window.open(
          `https://cpa-online-exam.pzacademy.com/landing/${this.currentPaper.paperId}`,
          '_blank'
        );
      } else {
        window.open(
          `https://online-exam.pzacademy.com/entry/${this.currentPaper.paperId}`,
          '_blank'
        );
      }
    },

    getBeforeMock(payload) {
      if (3 === this.currentPaper.examStatus && 1 === this.currentPaper.isParticipate) {
        this.ma_getRedoBeforeMock(payload);
      } else {
        this.ma_getBeforeMock(payload);
      }
    },

    go2MockWithPaper(paper) {
      $(`#MockExam`).modal('hide');
      this.isShowMock = true;
      this.isTakingExam = true;
      this.eventTitle = paper.paperName;
      this.currentPaper = paper;
      this.getBeforeMock({ paperId: paper.paperId });
    },

    go2Mock() {
      $(`#MockExam`).modal('hide');
      $('#selectableModal').modal('hide');
      this.isShowMock = true;
      this.isTakingExam = true;
      this.eventTitle = this.currentPaper.paperName;
      // this.currentPaper = paper;
      //this.getBeforeMock({ paperId: this.currentPaper.paperId });
    },

    async goThroughMock(paper) {
      $(`#MockExam`).modal('hide');
      this.isShowMock = true;
      this.isTakingExam = false;
      this.eventTitle = paper.paperName;
      this.currentPaper = paper;
      this.getMockData({
        paperId: paper.paperId,
      });
    },

    async redoMock(paper) {
      Swal.fire({
        title: '确认重新参加考试吗？',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then((result) => {
        if (result.value) {
          if (paper.isComputerExam) {
            this.openSelectableModal(paper);
          } else {
            this.go2MockWithPaper(paper);
          }
        }
      });
    },

    closeMock() {
      this.isShowMock = false;
      this.$store.commit('Events/GET_QUESTION_LIST_SUCCESS', []);
      this.$store.commit('Events/GET_QUESTION_SUCCESS', {});
      this.$store.commit('Events/GET_BEFORE_MOCK_SUCCESS', {});
      this.$store.commit('Events/GET_AFTER_MOCK_SUCCESS', {});
    },

    getMock() {
      this.getMockData({
        examStatus: this.currentPaper.examStatus,
        paperId: this.currentPaper.paperId,
        playedVoice: this.currentPaper.playedVoice,
      });
    },

    async handIn(payload) {
      if (payload) {
        await this.handInPaper({ ...payload, paperId: this.currentPaper.paperId });
      } else {
        await this.handInPaper({ paperId: this.currentPaper.paperId, auto: false });
      }
      this.hasAfter = false;
    },

    async doAnswer(payload) {
      await this.answer({ ...payload, paperId: this.currentPaper.paperId });
    },

    goToQuestion(questionId) {
      this.getQuestion({ paperId: this.currentPaper.paperId, questionId });
    },

    async updateQuestionHtml() {
      await this.ma_updateQuestionHtml({
        paperId: this.currentPaper.paperId,
        questionId: this.Question.questionId,
      });
    },

    saveQuestionRangyMark(payload) {
      this.mm_SAVE_QUESTION_RANGY_MARK(payload);
    },

    getQuestions(payload) {
      this.getMockData({
        paperId: payload.paperId,
      });
    },

    setQuestion(payload) {
      this.$store.commit('Events/SET_QUESTION', payload);
    },

    backToPaper() {
      this.isTakingExam = false;
      this.$store.commit('Events/GET_QUESTION_LIST_SUCCESS', []);
      this.$store.commit('Events/GET_QUESTION_SUCCESS', {});
      this.$store.commit('Events/GET_BEFORE_MOCK_SUCCESS', {});
      this.$store.commit('Events/GET_AFTER_MOCK_SUCCESS', {});
      this.getMockData({
        paperId: this.currentPaper.paperId,
        playedVoice: this.currentPaper.playedVoice,
      });
    },

    async openMockExamModal() {
      await this.fetchEvents();
      $(`#MockExam`).modal('show');
    },
  },

  created() {
    this.fetchEvents();
    this.itvlMockFinish = setInterval(() => {
      if (cookieHasItem('mock_finish_paperId')) {
        cookieRemoveItem('mock_finish_paperId');
        this.fetchEvents();
        $('#selectableModal').modal('hide');
        $(`#MockExam`).modal('hide');
      }
    }, 1000);
    this.$bus.once('login-modal-closed', this.fetchEvents);
  },

  mounted() {
    this.loadCKEditorScript();
  },

  beforeDestroy() {
    clearInterval(this.itvlMockFinish);
    this.$bus.off('login-modal-closed', this.fetchEvents);
  },
};
